import clsx from 'clsx'
import React, { useState, useEffect, useCallback } from 'react'
import stylesGlobal from '../../styles/referral/global.module.css';
import stylesPaymentHistory from './paymenthistory.module.css';
import paymentHistoryDummyJson from '../../dummyData/GetTransactionDetailsAPIContract.json';
import PaymentCardsFullLayout from './PaymentCardsFullLayout';


const FullPayoutHistory: React.FC = () => {

    const [transactionsHistory, setTransactionsHistory] = useState<any[]>(paymentHistoryDummyJson?.response?.response?.data?.transactions);
    const [singlPageList, setSinglPageList] = useState<number>(5);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(1);

    const [checkScroll, setCheckScroll] = useState<any>({
        showPaymentTransaction: true,
        showWalletTransaction: true,
        //walletLastSelectedItem: 39,
        paymentLastSelectedItem: null,
       // walletLastSelectedTime: 1744023197000,
       // fieldToFetch: null,
        count: 15,
        filterCodes: ['THTF_000'],
        // dateFilter: {
        //     startTime: null,
        //     endTime: null,
        // }
    });



  return (
    <div className={clsx(stylesPaymentHistory.paymentWrapper, stylesGlobal.container, stylesGlobal.pb20, stylesPaymentHistory.stickybotspac)}>
  
      <PaymentCardsFullLayout checkScroll={true} />
     
  </div>
  )
}

export default FullPayoutHistory;
